






























import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { QueryBankCodeById, CreateBankCode,UpdateBankCode } from '@/api'
import { Message } from 'element-ui'
import { ElForm } from 'element-ui/types/form'
import Rules from '@/utils/rules'
import constan from '@/utils/constant'
import { VImageUpload } from '@/components/upload'

@Component({
  components: {VImageUpload},
})
export default class EditBankCodeDialog extends Vue {
  private show = false
  private data: any ={
    bankCode: undefined,
    huifuBankCode: undefined,
    llpayBankCode: undefined,
    bankName: undefined,
    enableStatus: undefined,
    bankIcon: '',
    bankIconList:[]
  }
  private requiredRule = { required: true, message: '不能为空', trigger: 'blur' }
  private rules = {
    bankCode: [this.requiredRule],
    huifuBankCode: [this.requiredRule],
    llpayBankCode: [this.requiredRule],
    bankName: [this.requiredRule],
    //- bankIcon: [this.requiredRule],
    enableStatus: [this.requiredRule],
  }
  private type = 'add'
  private enableStatusOptions = constan.PlatformStatus

  private get isPreview() {
    if (this.type == 'preview') {
      return true
    }
    return false
  }

  @Emit('close')
  private close() {
    (this.$refs.form as ElForm).resetFields()
    this.show = false
  }

  public async open(type: string, bankCodeId: number | null = null) {
    this.show = true
    this.type = type
    this.data = {
      bankCode: undefined,
      huifuBankCode: undefined,
      llpayBankCode: undefined,
      bankName: undefined,
      enableStatus: 1,
      bankIcon: '',
      bankIconList:[]
    }

    if (bankCodeId) {
      const result = await QueryBankCodeById({ id: bankCodeId });
      if(result.bankIcon){
        result.bankIconList = result.bankIcon.split(',').map((e: string) => {
            return { url: e }
          })
      } else {
        result.bankIconList = []
      }
      this.data = result
    }
  }

  public async save() {
    this.data.bankIcon = this.data.bankIconList.map((e: any) => e.url).join(',')
    const f = this.$refs.form as ElForm
    f.validate(async (success: boolean) => {
      if (!success) {
        return
      }
      if(this.type == 'add'){
        await CreateBankCode(this.data)
      } else if (this.type == 'update'){
        await UpdateBankCode(this.data)
      }
      Message.success('保存')
      this.close()
    })
  }
}
